export default function publicAsset(path: string): string {
    return (import.meta.env.VITE_PUBLIC_URL || '') + path
}
